<mat-dialog-content>
  <div class="container p-2 align-middle">
    <div class="row justify-content-center">
      <div class="col-auto">
        INSERIR LINK
      </div>
    </div>
    <mat-divider class="my-3"></mat-divider>
    <form [formGroup]="form" (submit)="onSubmit()">
      <div class="row">
        <div class="col-12">
          <mat-form-field style="width: 100%;">
            <mat-label [translate]="'city-profile-certification/indicator/link'"></mat-label>
            <input formControlName="link" matInput>
            <mat-error *ngIf="link.touched && link.invalid && link.errors?.required"
              [translate]="'city-profile-certification/indicator/link-required'">
              Please provide url
            </mat-error>
            <mat-error *ngIf="link.touched && link.invalid && link.errors?.pattern"
              [translate]="'city-profile-certification/indicator/link-error'">
              Please provide valid url
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
    <div class="row justify-content-end">
      <div class="col-auto btn-container">
        <button class="cancel" mat-stroked-button (click)="onNoClick()">
          <span [translate]="'city-profile-certification/indicator/cancel'"></span>
        </button>
      </div>
      <div class="col-auto btn-container">
        <button class="submit" mat-flat-button (click)="onSubmit()">
          <span [translate]="'city-profile-certification/indicator/ok'"></span>
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>